import { defaultState } from "./reducer"

const StateHandler = (state) => {
    return {
        fetchListing: () => {
            return {
                ...state,
                isLoading: true
            }
        },
        fetchListingSuccess: (payload) => {
            return {
                ...state,
                listing: payload ?? [],
                isLoading: false,
            }
        },
        fetchListingError: (payload) => {
            return {
                ...state,
                error: payload,
            }
        },
        clearListing: () => {
            return defaultState
        }
    }
}

export {
    StateHandler
}


// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/reducers/handler.ts